import styled, { css } from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 40px;
        padding: 40px;
        background-color: ${({ theme }) => theme.color.white};
        border-radius: 16px;
    `,

    "AreaDiv": styled.div`
        display: flex;
        flex-direction: column;
        gap: 16px;

        & > h2 {
            ${({ theme }) => theme.font.small_bold};

            & > span {
                color: ${({ theme }) => theme.color.major};
                ${({ theme }) => theme.font.small_bold};
            }
        }
    `,
    "AreaHeader": styled.div`
        display: flex;
        justify-content: space-between;
        align-items: center;
    
        & > h2 {
            ${({ theme }) => theme.font.small_bold};

            & > span {
                color: ${({ theme }) => theme.color.major};
                ${({ theme }) => theme.font.small_bold};
            }
        }

        & > div {
            width: fit-content;
            display: flex;
            gap: 8px;
        }
    `,

    "QuestionDiv": styled.div`
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 16px 0px;
        border-top: 1px solid ${({ theme }) => theme.color.grey2};
    `,
    "QuestionTitle": styled.div`
        display: flex;
        align-items: center;
        gap: 12px;

        & > h2 {
            color: ${({ theme }) => theme.color.major};
            ${({ theme }) => theme.font.small_bold};
        }
    `,
    "QuestionInput": styled.input`
        flex-grow: 1;
        ${({ theme }) => theme.font.small};

        ${({ $small }) => $small && css`
            ${({ theme }) => theme.font.extra_small};
            text-align: center;
            width: 50px;
            border: 1px solid ${({ theme }) => theme.color.grey3};
            border-radius: 4px;
            flex-grow: 0;
            margin-top: 4px;
        `}
    `,

    "ControlDiv": styled.div`
        width: fit-content;
        display: flex;
        justify-content: center;
        gap: 4px;

         & > button {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 24px;
            height: 24px;
            border-radius: 4px;
            background-color: ${({ theme }) => theme.color.grey2};
        }
    `,
    "ChoiceDiv": styled.div`
        display: flex;
        flex-direction: column;
        gap: 4px;
    `,
    "Choice": styled.div`
        display: flex;
        align-items: center;
        gap: 16px;
        padding: 8px 12px;
        border: 1px solid ${({ theme }) => theme.color.grey3};
        border-radius: 4px;

        & > button {
            display: flex;
            align-items: center;
        }

        & > input {
            width: 100%;
            ${({ theme }) => theme.font.extra_small};
        }
    `,
}